import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { OnDatalayerProps } from '@/features/shared/HOCs/withGTM.interface';

enum Selectors {
  Headline = '.gtm-headline',
  Gallery = '.gtm-gallery',
  Scroll = '.gtm-scroll',
  Photo = '.gtm-photo',
  ImageName = 'data-imagename',
}

export const mapTarget = mapTargetBySelectors([
  Selectors.Gallery,
  Selectors.Scroll,
  Selectors.Photo,
]);

export const onDatalayer = ({ componentRef, target }: OnDatalayerProps) => {
  if (!target) {
    return undefined;
  }

  const variantName = (target?.closest('[data-datalayer-variant]') as HTMLDivElement)?.dataset
    ?.datalayerVariant;
  const isPhoto = target?.classList.contains(Selectors.Photo.replace('.', ''));
  const isGallery = target?.classList.contains(Selectors.Gallery.replace('.', ''));
  const imageName = target?.getAttribute(Selectors.ImageName) || '';

  if (isPhoto) {
    return {
      event: 'clickPhoto',
      eventCategory: 'Image Gallery',
      imageName,
      ...(variantName && { variant_name: variantName }),
    };
  }

  if (isGallery) {
    const documentHeadline =
      componentRef?.current?.querySelector(Selectors.Headline)?.textContent || '';

    return {
      event: 'clickGallery',
      eventCategory: 'Image Gallery',
      documentHeadline,
      imageName,
      ...(variantName && { variant_name: variantName }),
    };
  }

  // Scroll
  return {
    event: 'scrollGallery',
    eventCategory: 'Image Gallery',
    ...(variantName && { variant_name: variantName }),
  };
};
